export default __webpack_public_path__ + "static/media/compressed.82616a1d.png";